import { BuySection } from '@/components/dashboard/BuySection'

// Wider than every other page's shared 1280px cap - deliberately, not an oversight. The CoW
// Swap widget lays itself out differently depending on how much real width it actually gets
// (e.g. an orders table beside the swap card instead of stacked below it), so this page trades
// consistency with the rest of the app for giving the widget room to use its own wider layout.
export function BuyPage() {
  return (
    <div style={{ maxWidth: 1800, margin: '0 auto', padding: '24px' }}>
      <BuySection />
    </div>
  )
}
